<template>
  <div>
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增角色</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="{ $index }">{{ (page - 1) * pageSize + $index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="roleName" label="角色名称" width="200" />
      <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" :disabled="isSystem(row.roleCode)" @click="openEdit(row)">编辑</el-button>
          <el-button
            type="text"
            :disabled="row.roleCode==='SUPPLIER' || row.roleCode==='WORKER'"
            @click="openMenus(row)"
          >菜单权限</el-button>
          <el-button type="text" @click="openCopy(row)">复制</el-button>
          <el-button
            type="text"
            class="op-danger"
            :disabled="isSystem(row.roleCode)"
            @click="onDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑角色':'新增角色'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="角色名称" required>
          <el-input v-model="form.roleName" maxlength="32" placeholder="如 项目经理" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="菜单权限" :visible.sync="menuVisible" width="480px">
      <p class="tip" v-if="menuRole">角色：{{ menuRole.roleName }}</p>
      <p class="tip" v-if="menuRole && menuRole.roleCode==='TENANT_ADMIN'">企业管理员默认拥有全部公司菜单，此处配置作预留。</p>
      <el-tree
        ref="menuTree"
        v-loading="menuLoading"
        :data="menuTree"
        node-key="id"
        show-checkbox
        default-expand-all
        :props="{ label: 'name', children: 'children' }"
      />
      <div slot="footer">
        <el-button @click="menuVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveMenus">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="复制角色" :visible.sync="copyVisible" width="480px">
      <el-form :model="copyForm" label-width="90px">
        <el-form-item label="来源">{{ copySource && copySource.roleName }}</el-form-item>
        <el-form-item label="新名称" required>
          <el-input v-model="copyForm.roleName" maxlength="32" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="copyForm.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="copyVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveCopy">复制</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listRoles, saveRole, deleteRole, getRoleMenus, saveRoleMenus, copyRole, listAssignableMenus
} from '../../api/sys'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

const SYSTEM_CODES = [
  'TENANT_ADMIN',
  'SUPPLIER',
  'WORKER',
  'PROJECT_MANAGER',
  'DESIGNER',
  'WATER_ELECTRIC',
  'PAINT',
  'TILE',
  'WOOD'
]

export default {
  name: 'SysRole',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      list: [],
      loading: false,
      saving: false,
      visible: false,
      form: {},
      originalCode: '',
      menuVisible: false,
      menuLoading: false,
      menuRole: null,
      menuTree: [],
      copyVisible: false,
      copySource: null,
      copyForm: {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    isSystem(code) {
      return SYSTEM_CODES.includes(code)
    },
    async load() {
      this.loading = true
      try {
        const res = await listRoles()
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    openEdit(row) {
      if (row && this.isSystem(row.roleCode)) {
        this.$message.warning('系统预置角色不可编辑')
        return
      }
      this.form = row
        ? { id: row.id, roleCode: row.roleCode, roleName: row.roleName || '', remark: row.remark || '' }
        : { id: null, roleCode: '', roleName: '', remark: '' }
      this.originalCode = row ? row.roleCode : ''
      this.visible = true
    },
    async save() {
      const f = this.form
      if (!f.roleName) return this.$message.warning('请填写角色名称')
      this.saving = true
      try {
        await saveRole(f)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    async openMenus(row) {
      this.menuRole = row
      this.menuVisible = true
      this.menuLoading = true
      try {
        if (!this.menuTree.length) {
          const treeRes = await listAssignableMenus()
          this.menuTree = treeRes.data || []
        }
        const res = await getRoleMenus(row.id)
        const ids = res.data || []
        this.$nextTick(() => {
          if (this.$refs.menuTree) {
            this.$refs.menuTree.setCheckedKeys(ids)
          }
        })
      } finally {
        this.menuLoading = false
      }
    },
    async saveMenus() {
      if (!this.menuRole) return
      const tree = this.$refs.menuTree
      const checked = tree.getCheckedKeys()
      const half = tree.getHalfCheckedKeys()
      const menuIds = [].concat(checked, half)
      this.saving = true
      try {
        await saveRoleMenus(this.menuRole.id, menuIds)
        this.$message.success('菜单权限已保存')
        this.menuVisible = false
      } finally {
        this.saving = false
      }
    },
    openCopy(row) {
      this.copySource = row
      this.copyForm = {
        roleCode: '',
        roleName: (row.roleName || '') + '副本',
        remark: row.remark || ''
      }
      this.copyVisible = true
    },
    async saveCopy() {
      if (!this.copySource) return
      const f = this.copyForm
      if (!f.roleName) return this.$message.warning('请填写新角色名称')
      this.saving = true
      try {
        await copyRole(this.copySource.id, f)
        this.$message.success('已复制')
        this.copyVisible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除角色「${row.roleName || row.roleCode}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteRole(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.tip { margin: 0 0 10px; color: #64748b; font-size: 13px; }
.op-danger { color: #ef4444; }
</style>
